module.exports = __webpack_public_path__ + "img/5.ad347a2b.png";